module.exports = __parcel__import__.meta.resolve("2d55s");